export default "__VITE_ASSET__aTLwxVVf__"